import { DocsExamples } from "@/types/docs-reference";

import primary from "./primary.mml";

export const examples: DocsExamples = {
  primary: {
    title: "Basic m-attr-lerp",
    description: "This is a basic m-attr-lerp.",
    code: primary,
  },
};
